import { TableCell, TableRow } from "@mui/material";
import { DemoExResponse } from "src/services/admin/queries/NetTypes";

import cols from "../Cols";
import CollapseTable from "./CollapseTable/CollapseTable";
import ContextRow from "./context";
import useRowStore from "./store";

export default function RowDemo(demo: DemoExResponse) {
	const [state, actions] = useRowStore();
	return (
		<ContextRow.Provider value={{ actions, state }}>
			<TableRow hover>
				{cols.map(({ Cell, align }, index) => (
					<TableCell align={align} key={index}>
						<Cell {...demo} />
					</TableCell>
				))}
			</TableRow>
			<TableRow hover>
				<CollapseTable id={demo.demoId} />
			</TableRow>
		</ContextRow.Provider>
	);
}
